import React from "react";
import { PropsWithoutRef } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { SIDEBAR_WIDTH } from "../constants";
import { ENUM_ROUTES } from "../RoutesEnum";
// import StarsIcon from '@material-ui/icons/Stars';
import StarsIcon from "@mui/icons-material/Stars";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import useAuth from "../hooks/useAuth";
import { ROLES } from "../utils/enums";
interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAuth()


  const getPermissions = () => {
    // Support both `accessRole` and `accessRoleId` shapes
    // Each contains { permission: Permission[] }
    // Fallback to empty array when missing
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const roleContainer: any = (user as any)?.accessRole || (user as any)?.accessRoleId;
    return roleContainer?.permission || [];
  };

  const isAdminRole = () => {
    const role = (user as unknown as { role?: number | string })?.role;
    return role === ROLES.ADMIN || role === "ADMIN";
  };

  const canView = (label: string): boolean => {
    if (isAdminRole()) return true;
    const permissions = getPermissions();
    const matched = permissions?.find((p: { label: string }) => p?.label === label);
    return !!matched?.isView;
  };


  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <figure>
          <img
            src="/static/images/authLogo2.png"
            alt=""
            onClick={() => navigate("/dashboard")}
          />
        </figure>
        {/* <h1>Logo</h1> */}
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {canView("Dashboard") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/dashboard"}
            onClick={() => navigate("/dashboard")}
          >
            <ListItemIcon>
              <img src="/static/images/dashboard_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Dashboard" />
          </ListItemButton>
        )}

        {canView("Manage User / Owner") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-customers" ||
              location.pathname === "/manage-customers/detail" ||
              location.pathname === "/manage-customers/add"
            }
            onClick={() => navigate("/manage-customers")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage User / Owner" />
          </ListItemButton>
        )}

        {canView("Manage Venue / Storage") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-venue-owners" ||
              location.pathname === "/manage-venue-owners/add" ||
              location.pathname === "/manage-venue-owners/edit"
            }
            onClick={() => navigate("/manage-venue-owners")}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Venue / Storage"
            />
          </ListItemButton>
        )}
        {/* <-------------Manage Booking Requests----------------> */}
        {canView("Manage Booking Requests") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.MANAGE_BOOKINGS ||
              location.pathname === ENUM_ROUTES.ADD_BOOKING ||
              location.pathname === ENUM_ROUTES.VIEW_BOOKING_DETAILS
            }
            onClick={() => navigate(ENUM_ROUTES.MANAGE_BOOKINGS)}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Booking Requests"
            />
          </ListItemButton>
        )}
        {/* <-------------Manage Booking Requests----------------> */}

        {/* <-------------Manage Loyalty Points----------------> */}
        {canView("Loyalty Points") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.LOYALTY_POINTS_DETAILS ||
              location.pathname === ENUM_ROUTES.MANAGE_LOYALTY_POINTS
            }
            onClick={() => navigate(ENUM_ROUTES.MANAGE_LOYALTY_POINTS)}
          >
            <ListItemIcon>
              <StarsIcon />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Loyalty Points" />
          </ListItemButton>
        )}
        {/* <-------------Manage Loyalty Points----------------> */}
        {canView("Manage Facilities") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === ENUM_ROUTES.MANAGE_FACILITIES}
            onClick={() => navigate(ENUM_ROUTES.MANAGE_FACILITIES)}
          >
            <ListItemIcon>
              <img src="/static/images/category_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Facilities" />
          </ListItemButton>
        )}

        {canView("Discount and Coupon Management") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.DISCOUNT_COUPON_MANAGEMENT ||
              location.pathname === ENUM_ROUTES.ADD_DISCOUNT ||
              location.pathname === ENUM_ROUTES.DISCOUNT_DETAILS
            }
            onClick={() => navigate(ENUM_ROUTES.DISCOUNT_COUPON_MANAGEMENT)}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Discount and Coupon Management"
            />
          </ListItemButton>
        )}

        {canView("Manage Banner") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-banners" ||
              location.pathname === ENUM_ROUTES.ADD_BANNERS ||
              location.pathname === ENUM_ROUTES.BANNERS_DETAILS
            }
            onClick={() => navigate("/manage-banners")}
          >
            <ListItemIcon>
              <img src="/static/images/category_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Banner" />
          </ListItemButton>
        )}
        {/* <--------ENUM_ROUTES.MANAGE_NEWS--------> */}
        {canView("Manage News") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.MANAGE_NEWS ||
              location.pathname === ENUM_ROUTES.ADD_NEWS ||
              location.pathname === ENUM_ROUTES.NEWS_DETAILS
            }
            onClick={() => navigate(ENUM_ROUTES.MANAGE_NEWS)}
          >
            <ListItemIcon>
              <img src="/static/images/category_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage News" />
          </ListItemButton>
        )}
        {/* <--------ENUM_ROUTES.MANAGE_NEWS--------> */}

        {/* <--------ENUM_ROUTES.MANAGE_BLOGS--------> */}
        {canView("Manage Blogs") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.MANAGE_BLOGS ||
              location.pathname === ENUM_ROUTES.ADD_BLOG ||
              location.pathname === ENUM_ROUTES.BLog_DETAILS
            }
            onClick={() => navigate(ENUM_ROUTES.MANAGE_BLOGS)}
          >
            <ListItemIcon>
              <img src="/static/images/category_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Blogs" />
          </ListItemButton>
        )}
        {/* <--------ENUM_ROUTES.MANAGE_BLOGS--------> */}

        {canView("Manage Categories") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === ENUM_ROUTES.MANAGE_CATEGORIES ||
              location.pathname.startsWith(ENUM_ROUTES.MANAGE_SUBCATEGORY) ||
              location.pathname.startsWith(ENUM_ROUTES.CATEGORY_DETAILS)
            }
            onClick={() => navigate(ENUM_ROUTES.MANAGE_CATEGORIES)}
          >
            <ListItemIcon>
              <img src="/static/images/category_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Categories" />
          </ListItemButton>
        )}
        {canView("Manage FAQ") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === ENUM_ROUTES.MANAGE_FAQ}
            onClick={() => navigate(ENUM_ROUTES.MANAGE_FAQ)}
          >
            <ListItemIcon>
              <img src="/static/images/support_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage FAQ" />
          </ListItemButton>
        )}

        {canView("Manage Payments") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-payments"}
            onClick={() => navigate("/manage-payments")}
          >
            <ListItemIcon>
              <img src="/static/images/money_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Payments" />
          </ListItemButton>
        )}

        {canView("Manage Host Payout") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-host-payout"}
            onClick={() => navigate("/manage-host-payout")}
          >
            <ListItemIcon>
              <img src="/static/images/money_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Host Payout" />
          </ListItemButton>
        )}

        {canView("Manage Refunds") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === ENUM_ROUTES.MANAGE_REFUNDS}
            onClick={() => navigate(ENUM_ROUTES.MANAGE_REFUNDS)}
          >
            <ListItemIcon>
              <img src="/static/images/money_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Refunds" />
          </ListItemButton>
        )}

        {canView("Manage Sub-Admin") && (
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-subadmin" ||
              location.pathname === "/manage-subadmin/add" ||
              location.pathname === "/manage-subadmin/detail" ||
              location.pathname === "/manage-subadmin/roles" ||
              location.pathname === "/manage-subadmin/roles/add" ||
              location.pathname === "/manage-subadmin/roles/detail"
            }
            onClick={() => navigate("/manage-subadmin")}
          >
            <ListItemIcon>
              <img src="/static/images/subadmin_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Sub-Admin" />
          </ListItemButton>
        )}

        {canView("Revenue Analytics") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/revenue-analytics"}
            onClick={() => navigate("/revenue-analytics")}
          >
            <ListItemIcon>
              <img src="/static/images/status_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Revenue Analytics" />
          </ListItemButton>
        )}

        {canView("Manage Customer Support") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-customer-support"}
            onClick={() => navigate("/manage-customer-support")}
          >
            <ListItemIcon>
              <img src="/static/images/support_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Customer Support"
            />
          </ListItemButton>
        )}

        {canView("Notification Management") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-notifications"}
            onClick={() => navigate("/manage-notifications")}
          >
            <ListItemIcon>
              <img src="/static/images/notification2_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Notification Management"
            />
          </ListItemButton>
        )}

        {canView("Manage Reviews") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-reviews"}
            onClick={() => navigate("/manage-reviews")}
          >
            <ListItemIcon>
              <img src="/static/images/rating_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Reviews" />
          </ListItemButton>
        )}

        {canView("Manage CMS Pages") && (
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-cms"}
            onClick={() => navigate("/manage-cms")}
          >
            <ListItemIcon>
              <img src="/static/images/cms_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage CMS Pages" />
          </ListItemButton>
        )}
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar-main-div"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
